module.exports = __webpack_public_path__ + "img/avatar.99ed4258.2fcd7781.svg";